import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import AnimatedSection from "@/components/AnimatedSection";
import { useBookingPopup } from "@/hooks/use-booking-popup";
import { useEffect } from "react";

export default function ReviewsSection() {
  const { openPopup } = useBookingPopup();

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://reputationhub.site/reputation/assets/review-widget.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-24 bg-[#fcfcfc] font-body">
      <AnimatedSection className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 text-primary font-display font-bold text-3xl uppercase tracking-wide mb-4">
            <Star className="w-8 h-8 text-accent" strokeWidth={2} /> WHAT OUR
            CLIENTS SAY
          </div>
          <div className="flex justify-center gap-1 mb-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-6 h-6 fill-accent text-accent" />
            ))}
          </div>
        </div>

        <div className="w-full mt-12 min-h-[400px]">
          <iframe
            title="Client Reviews"
            className="lc_reviews_widget"
            src="https://reputationhub.site/reputation/widgets/review_widget/LybUg0eKBAfPYJVWJI73?widgetId=6a3e7998685825b528b942be"
            frameBorder="0"
            scrolling="no"
            style={{ minWidth: "100%", width: "100%" }}
            loading="lazy"
          ></iframe>
        </div>

        <div className="text-center mt-16">
          <Button
            onClick={openPopup}
            className="bg-primary hover:bg-primary/90 text-white font-bold rounded-sm py-6 px-10 tracking-wide uppercase"
          >
            START YOUR TRAINING JOURNEY
          </Button>
        </div>
      </AnimatedSection>
    </section>
  );
}
